import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getHomeRoute } from "@/utils/navigation";
/**
 * Root redirect component that handles autoLogin query parameter
 * and redirects authenticated users to their home route.
 *
 * The AuthContext will process the autoLogin query parameter in its useEffect.
 * This component waits for that to complete, then redirects appropriately.
 */
export const RootRedirect = () => {
    const { isAuthenticated, isLoading, user } = useAuth();
    // Wait for auth to finish loading (especially if autoLogin is being processed)
    if (isLoading) {
        return (_jsx("div", { style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
            }, children: "Loading..." }));
    }
    // If authenticated, redirect to home route
    if (isAuthenticated && user) {
        return _jsx(Navigate, { to: getHomeRoute(user.role), replace: true });
    }
    // If autoLogin was present but authentication failed, still redirect to login
    // (the query parameter will be lost, but that's okay for dev auto-login)
    // Otherwise redirect to login
    return _jsx(Navigate, { to: "/login", replace: true });
};
